import React, { useState } from "react";
import { Star, Quote, ChevronLeft, ChevronRight, ExternalLink } from "lucide-react";
import { testimonials } from "../mock";

export default function Testimonials() {
  const [idx, setIdx] = useState(0);
  const perView = 3;
  const maxStart = Math.max(0, testimonials.length - perView);
  const start = Math.min(idx, maxStart);
  const visible = testimonials.slice(start, start + perView);

  return (
    <section className="py-16 lg:py-20 bg-gradient-to-b from-teal-50/50 to-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center max-w-2xl mx-auto mb-12">
          <p className="inline-block text-teal-600 font-bold uppercase tracking-widest text-xs bg-teal-100/60 px-4 py-1.5 rounded-full mb-4">Testimonials &amp; Reviews</p>
          <h2 className="text-3xl sm:text-4xl font-extrabold text-slate-900">Customer Feedback</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-6">
          {visible.map((t) => (
            <div key={t.name} className="bg-white rounded-2xl p-6 border border-slate-100 card-shadow flex flex-col">
              <Quote className="w-8 h-8 text-teal-200 mb-3" />
              <div className="flex items-center gap-0.5 mb-3">
                {[...Array(5)].map((_, k) => <Star key={k} className="w-4 h-4 fill-amber-400 text-amber-400" />)}
              </div>
              <p className="text-sm text-slate-600 leading-relaxed flex-1">{t.text}</p>
              <div className="flex items-center gap-3 mt-5 pt-4 border-t border-slate-100">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-teal-500 to-blue-600 text-white flex items-center justify-center font-bold text-sm">{t.initials}</div>
                <div>
                  <div className="font-semibold text-slate-900 text-sm">{t.name}</div>
                  <div className="text-xs text-slate-400">Verified Customer · {t.ago}</div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <div className="flex items-center justify-center gap-4 mt-8">
          <button onClick={() => setIdx((p) => Math.max(0, p - 1))} disabled={start === 0} className="w-11 h-11 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:border-teal-400 hover:text-teal-600 disabled:opacity-40 transition-colors">
            <ChevronLeft className="w-5 h-5" />
          </button>
          <span className="text-sm text-slate-500 font-medium">{String(start + 1).padStart(2, "0")} / {String(testimonials.length).padStart(2, "0")}</span>
          <button onClick={() => setIdx((p) => Math.min(maxStart, p + 1))} disabled={start === maxStart} className="w-11 h-11 rounded-full border border-slate-200 flex items-center justify-center text-slate-600 hover:border-teal-400 hover:text-teal-600 disabled:opacity-40 transition-colors">
            <ChevronRight className="w-5 h-5" />
          </button>
        </div>
        <div className="text-center mt-6">
          <a href="#" className="inline-flex items-center gap-2 text-teal-600 font-semibold hover:text-teal-700">
            <ExternalLink className="w-4 h-4" /> Write A Review
          </a>
        </div>
      </div>
    </section>
  );
}
